import { inject, Pipe, PipeTransform } from '@angular/core';
import { AbstractTransport } from '../../models/abstract-transport.model';
import { formatNumber } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'transportTotal',
  standalone: true,
})
export class TransportTotalPipe implements PipeTransform {
  readonly #translateService = inject(TranslateService);

  transform(value: AbstractTransport): string {
    let result = '';
    if (value.totalPallets && value.totalPallets > 0) {
      result += this.addValueWithSeparator(result, '' + value.totalPallets);
      if (value.totalPallets === 1) {
        result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.pallet');
      } else {
        result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.pallets');
      }
    }
    if (value.totalParcel && value.totalParcel > 0) {
      result += this.addValueWithSeparator(result, '' + value.totalParcel);
      if (value.totalPallets === 1) {
        result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.parcel');
      } else {
        result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.parcels');
      }
    }

    if (value.totalPallets && value.totalPallets > 0 && value.totalLDM && value.totalLDM > 0) {
      result += this.addValueWithSeparator(result, '' + formatNumber(value.totalLDM, this.#translateService.currentLang, '1.2-2'));
      result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.ldm');
    }

    if (value.totalWeight && value.totalWeight > 0) {
      result += this.addValueWithSeparator(result, '' + formatNumber(value.totalWeight, this.#translateService.currentLang, '1.2-2'));
      result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.weight');
    }

    if (value.totalVolume && value.totalVolume > 0) {
      result += this.addValueWithSeparator(result, '' + formatNumber(value.totalVolume, this.#translateService.currentLang, '1.2-2'));
      result += ' ' + this.#translateService.instant('baryApp.transport-card.items.total.volume');
    }

    return result + '';
  }

  private addValueWithSeparator(result: string, value: string): string {
    if (result && result.length > 0) {
      return ' - ' + value;
    }
    return value;
  }
}
